<template>
  <transition name="slide-fade">
    <div v-if="!isAccepted" id="cookie-bar">
      <div class="icon">
        <svg width="31" height="27" xmlns="http://www.w3.org/2000/svg">
          <g fill="#fff" fill-rule="evenodd">
            <path
              d="M5 6.884c.132-.157.253-.318.377-.478l.024-.032c.176-.239.342-.484.495-.739a14.1 14.1 0 0 1 .94-1.115 12.7 12.7 0 0 1 2.2-1.862 15.845 15.845 0 0 1 4.648-2.12c2.755-.73 5.717-.746 8.43.134a.385.385 0 0 0 .105.062c.314.114.62.238.934.365.19.078.383.153.575.215 1.9.916 3.563 2.303 4.77 4.002 1.313 1.849 2.18 4.053 2.43 6.292.426 3.835-1.061 7.718-3.716 10.54-2.51 2.67-6.039 4.618-9.795 4.83a11.496 11.496 0 0 1-4.238-.524 10.963 10.963 0 0 1-2.463-1.175c-.76-.644-1.47-1.344-2.166-2.056l-.006.007c-.116-.118-.234-.24-.348-.362-.052-.053-.11-.108-.165-.166l.037-.024c.224-.187.435-.507.623-.73l.765.473c-.036.032-.091.163-.13.194.544.554 1.122 1.075 1.768 1.514.682.442 1.412.804 2.183 1.08.845.28 1.723.45 2.618.509a11.64 11.64 0 0 0 2.63-.176c.094-.021.184-.056.281-.076l-.023-.028a1.466 1.466 0 0 1-.157-1.124c.2-.751 1.08-1.342 1.878-1.081.406.132.739.336.953.706.097.16.158.34.189.526a15.309 15.309 0 0 0 2.818-1.811 15.176 15.176 0 0 0 2.497-2.746 13.773 13.773 0 0 0 1.567-3.048c.301-.915.495-1.852.576-2.807.054-.936-.003-1.87-.17-2.798-.06-.288-.155-.563-.239-.847l-.009.062c-.199.747-1.08 1.34-1.877 1.081-.407-.132-.738-.34-.953-.707a1.483 1.483 0 0 1-.156-1.127c.196-.75 1.077-1.343 1.878-1.082.226.073.421.173.594.305-.083-.19-.15-.389-.242-.575a12.74 12.74 0 0 0-1.65-2.447l-.02-.023-.003-.005h-.004l-.02-.028c-.553-.6-1.172-1.13-1.838-1.608a.966.966 0 0 1-.798.112c-.277-.09-.5-.227-.652-.48a.956.956 0 0 1-.118-.543c-.395-.189-.796-.36-1.209-.51a13.62 13.62 0 0 0-3.075-.61 15.727 15.727 0 0 0-3.593.226 17.37 17.37 0 0 0-3.925 1.306c-.568.28-1.131.592-1.68.922-.7.425-1.352.913-1.981 1.432-.382.324-.748.661-1.11 1.008.063.093.137.177.189.277.145.284.236.546.293.857.038.224.034.427.02.65-.042.588-.303 1.123-.658 1.596l-.732-.298c.131-.322.23-.658.286-1l.006-.079c.022-.149.036-.296.037-.444a2.535 2.535 0 0 0-.192-1.056 2.4 2.4 0 0 0-.183-.352c-.064-.1-.145-.199-.225-.289-.03-.033-.064-.065-.095-.095z"
            />
            <path
              d="M5.24 10.652c.09-.247.039-.227.126-.462l.988.1a4.574 4.574 0 0 1 1.46.689 3 3 0 0 1 .705.713c.15.224.294.483.362.752.086.341.123.673.079 1.029a2.796 2.796 0 0 1-.243.851 4.056 4.056 0 0 1-.351.59c.18.073.361.147.531.244.397.238.8.513 1.104.874.307.363.563.731.735 1.18.153.38.249.798.263 1.208.018.868-.205 1.75-.672 2.474-.259.398-.534 1.215-.88 1.541l-.763-.483c.096-.123.397-.634.486-.767.227-.347.245-.764.362-1.16.113-.37.153-.774.14-1.164a2.976 2.976 0 0 0-.264-1.065c-.156-.361-.415-.672-.702-.931-.335-.29-.728-.491-1.138-.644a4.13 4.13 0 0 0-.407-.124 8.265 8.265 0 0 0-.718-.137c.344-.475.628-.985.847-1.53.096-.235.167-.491.2-.745.028-.236.02-.468-.07-.69a.772.772 0 0 0-.143-.248l-.018-.026c-.037-.064-.085-.127-.126-.187a3.011 3.011 0 0 0-.385-.343 2.399 2.399 0 0 0-.278-.162.364.364 0 0 0-.1-.123 2.441 2.441 0 0 0-.276-.2c-.133-.093-.288-.162-.438-.23-.069-.03-.14-.055-.209-.078a6.379 6.379 0 0 0-.447-.13c.134-.192.15-.37.24-.616z"
            />
            <path
              d="M8.99 21.016l.02-.032-.014.016-.005.016M22.127 20.939c.775.256 1.634-.33 1.827-1.07.096-.373.04-.774-.155-1.11-.213-.363-.535-.569-.926-.698-.775-.256-1.634.329-1.827 1.07-.096.373-.04.774.155 1.11.212.363.534.568.926.698M21.374 15.98c.259.085.547-.11.61-.355.073-.276-.103-.52-.358-.604-.259-.086-.547.109-.61.354-.072.276.103.52.358.604M14.031 16.754a.985.985 0 0 0 .103.741c.14.243.357.378.617.464.518.171 1.09-.217 1.218-.713a.983.983 0 0 0-.103-.741c-.14-.243-.357-.378-.617-.464-.518-.171-1.09.217-1.218.713M16.625 21.02c-.259-.085-.545.108-.608.356-.073.277.1.518.358.603.259.086.545-.108.608-.355.073-.277-.1-.518-.358-.603M19.752 9.96c.516.17 1.089-.22 1.216-.714a.986.986 0 0 0-.101-.74c-.14-.243-.357-.379-.619-.465-.516-.171-1.089.219-1.216.713a.986.986 0 0 0 .101.74c.141.243.357.379.619.465M13.247 7.04c-.514-.17-1.088.222-1.216.716-.139.549.205 1.032.722 1.204.514.17 1.088-.222 1.216-.716.139-.549-.205-1.033-.722-1.204M15.032 10.754c-.143.549.205 1.034.72 1.205.515.17 1.09-.215 1.216-.713.142-.549-.205-1.034-.72-1.205-.515-.17-1.09.216-1.216.713M18.376 3.98c.257.085.543-.11.608-.357.071-.275-.102-.517-.36-.603-.257-.085-.543.11-.608.357-.071.275.102.518.36.603M7.624 6.02c-.258-.085-.544.109-.607.356-.073.277.1.518.358.603.258.086.545-.108.608-.355.073-.277-.1-.518-.359-.603M12.624 22.021c-.26-.087-.547.106-.607.356-.074.275.098.516.359.602.26.087.548-.106.607-.356.074-.275-.103-.517-.359-.602M11.624 13.021c-.263-.087-.545.109-.606.356-.077.272.103.517.359.602.262.087.544-.108.605-.356.077-.271-.102-.517-.358-.602M26.376 14.979c.263.087.545-.108.606-.356.077-.271-.103-.517-.358-.602-.262-.087-.545.109-.606.356-.077.272.103.517.358.602M21.376 12.98c.262.086.546-.11.606-.357.077-.271-.103-.517-.358-.602-.262-.087-.546.109-.606.356-.077.271.103.517.358.602M10.003 6h.01c.809-.353 1.621-.708 2.436-1.045l-.012.006c1.464-.598 2.898-1.25 4.356-1.853l-.006.006c.069-.031.142-.06.213-.087L16.993 3c-1.245.224-2.447.545-3.604 1.05-1.19.52-2.304 1.226-3.389 1.928l.003.022M9.773 11.789c-.166-.349-.458-.598-.76-.789L9 11.019c.14.13.262.266.377.422l-.01-.011c.094.147.171.295.238.458.064.192.107.383.132.588.017.255.01.502-.018.752a5.218 5.218 0 0 1-.209.888c-.109.303-.24.588-.39.868l.007.016.01-.002c.461-.62.812-1.344.86-2.158a2.193 2.193 0 0 0-.224-1.051M12.037 18.832c.04.292.044.574.016.866l.003-.007c-.015.098-.029.196-.051.296l.009.013.013-.006c.299-.693.231-1.366-.212-1.994l-.024.008c.121.275.2.549.251.845l-.005-.021M3.032 20.754c-.142.552.203 1.034.72 1.205.516.171 1.088-.217 1.216-.713.142-.552-.203-1.034-.72-1.205-.516-.171-1.088.217-1.216.713M3.376 18.98c.263.086.545-.11.606-.357.077-.271-.103-.517-.359-.602-.262-.087-.544.109-.605.356-.077.271.103.517.358.602M.625 21.02c-.259-.085-.546.11-.61.357-.07.275.102.517.36.603.26.085.546-.11.61-.357.07-.275-.102-.517-.36-.603M2.377 16.98c.256.085.543-.11.607-.358.07-.275-.101-.516-.36-.602-.257-.085-.544.11-.608.358-.07.275.101.516.36.602"
            />
          </g>
        </svg>
      </div>
      <div class="info" v-html="info"></div>
      <a class="accept" @click="acceptCookie" herf="#">{{ button }}</a>
    </div>
  </transition>
</template>

<script>
import { setCookie, getCookie } from "@/plugins/helpers";

export default {
  name: "cookie-bar",
  data() {
    return {
      info: WPVUE.options.cookie_content,
      button: WPVUE.options.cookie_button,
      isAccepted: true
    };
  },
  computed: {},
  beforeMount() {
    this.isAccepted = this.checkCookie("acceptCookie", "accepted");
  },
  mounted() {
    //return this.checkCookie('acceptCookie', 'accepted')
  },
  methods: {
    acceptCookie() {
      setCookie("acceptCookie", "accepted", 60);
      this.isAccepted = true;
    },
    checkCookie(cookieName, value) {
      var cookie = getCookie(cookieName);
      if (cookie !== value) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss">
#cookie-bar {
  z-index: 9999;
  position: fixed;
  right: 15px;
  bottom: 15px;
  color: #fff;
  background-color: #00bcb5;
  padding: 15px;
  max-width: 350px;
  .info {
    font-size: 13px;
    line-height: 1.4;
    p {
      margin-top: 0 !important;
    }
    a {
      color: #000;
      text-decoration: underline;
    }
  }
  .icon {
    float: left;
    margin-right: 15px;
    margin-top: 3px;
  }
  @media print {
    display: none !important;
  }
  @media all and (max-width: 767px) {
    left: 15px;
  }
  .accept {
    text-transform: uppercase;
    text-align: center;
    display: block;
    border: 1px solid rgba(#fff, 0.98);
    padding: 8px 12px;
    background-color: #0a908b;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    transition: all 0.15s ease-in-out;
    &:hover,
    &:focus {
      color: #fff;
      background-color: #11c1bb;
    }
  }
}
</style>
